module.exports = __webpack_public_path__ + "media/images/bank_images/bradesco-ca36034d31497342e0d14146e413d73e.png";